export default "__VITE_ASSET__DJxzTtd3__"